import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FdaEditComponent } from './fda-edit.component';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { CommHistoryModule } from "src/app/shared/components/comm-history/comm-history.module";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AutoResizeInputDirective } from 'src/app/shared/helpers/auto-resize-input.directive';
import { FdaEditRoutingModule } from './fda-edit-routing.module';



@NgModule({
  declarations: [
    FdaEditComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    CommHistoryModule,
    ReactiveFormsModule,
    FormsModule,
    AutoResizeInputDirective,
    FdaEditRoutingModule
]
})
export class FdaEditModule { }
